<template>
  <tour
    root-element-selector="#tariffs-menu-item"
    title="Еще немного осталось до активации продаж"
    :offset-top="64"
    :offset-left="isCollapsedNavigation ? 40 : 190"
  >
    <template #text>
      <div class="mb-1">Выберите способ активации</div>
      <ul class="ul-list text-blue">
        <li class="mb-1">
          <router-link :to="{ name: RouteNames.CMList }" class="text-link" @click="closeActiveTour">
            Подключение к менеджеру каналов
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: RouteNames.TariffsControlled }" class="text-link" @click="closeActiveTour">
            Ручное создание тарифных планов
          </router-link>
        </li>
      </ul>
    </template>
    <template #arrow>
      <v-img :src="Arrow" width="50" class="arrow" />
    </template>
  </tour>
</template>

<script setup lang="ts">
import Arrow from '@/assets/img/pages/object/arrow2.svg';
import Tour from '@/core/components/common/Tour.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { useLayoutStore } from '@/core/store/layout';
import { useTourStore } from '@/core/store/tour';

const { closeActiveTour } = useTourStore();
const { isCollapsedNavigation } = useLayoutStore();
</script>

<style scoped lang="scss">
.arrow {
  position: absolute;
  bottom: calc(100% + 8px);
}
</style>
